import { PartnerType } from "@tm/isomorphic-utils";
import { ThemeProvider } from "styled-components";
import {
  DeviceContextV2,
  DeviceContextV2Type,
} from "../Contexts/DeviceContext";

export function withDeviceAndThemeProvider(
  comp: JSX.Element,
  device: DeviceContextV2Type,
  theme: {
    pageTheme: PartnerType;
  }
) {
  return (
    <DeviceContextV2.Provider value={device}>
      <ThemeProvider theme={theme}>{comp}</ThemeProvider>
    </DeviceContextV2.Provider>
  );
}
